import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const PlusCircleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon fill="none" viewBox="0 0 20 20" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.364 3.636c3.515 3.515 3.515 9.213 0 12.728-3.515 3.515-9.213 3.515-12.728 0-3.515-3.515-3.515-9.213 0-12.728 3.515-3.515 9.213-3.515 12.728 0zM4.794 4.793c-2.876 2.876-2.876 7.538 0 10.414 2.875 2.876 7.537 2.876 10.413 0 2.82-2.82 2.875-7.356.166-10.243l-.166-.17-.171-.167c-2.887-2.708-7.424-2.653-10.243.166zM10 5.91c.42 0 .765.316.813.723l.005.095v2.454h2.455c.452 0 .818.367.818.819 0 .42-.316.765-.723.813l-.095.005h-2.455v2.455c0 .452-.366.818-.818.818-.42 0-.765-.316-.813-.723l-.005-.095v-2.455H6.726c-.452 0-.818-.366-.818-.818 0-.42.316-.765.723-.813l.095-.005 2.454-.001V6.727c0-.452.367-.818.819-.818z"
            />
        </SvgIcon>
    );
};
